// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__TtopO","spinner__small":"styles_spinner__small__JkJ2U","fon":"styles_fon__9VYUe"};